module.exports = __webpack_public_path__ + "img/icons8-python.4948e676.svg";